import { useSyncExternalStore } from 'react';

/**
 * Speicherfehler bleiben sichtbar, bis eine spätere Änderung gespeichert wurde oder man den Hinweis
 * schließt – ein kurzer Toast reicht dafür nicht. Unabhängig vom Zustand der Live-Verbindung.
 * Ein Fehler kennt seine Karte: die Kartendetails zeigen nur Fehler dieser Karte, das Board alle.
 */
export interface SaveError {
  message: string;
  at: number;
  cardId: string | null;
}

let current: SaveError | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function reportSaveError(message: string, cardId: string | null = null) {
  current = { message, at: Date.now(), cardId };
  emit();
}

/** Ohne Karte: Fehler immer löschen; mit Karte: nur einen Fehler dieser Karte oder einen ohne Karte */
export function clearSaveError(cardId?: string | null) {
  if (!current) return;
  if (cardId && current.cardId && current.cardId !== cardId) return;
  current = null;
  emit();
}

export function useSaveError(cardId?: string): SaveError | null {
  const e = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
  if (!e) return null;
  return !cardId || e.cardId === cardId ? e : null;
}

/** Zu welcher Karte gehört eine Speichern-Mutation? (Schlüssel ['save', kartenId] oder Variablen mit id/cardId) */
export function mutationCardId(m: { options: { mutationKey?: readonly unknown[] }; state: { variables?: unknown } }): string | null {
  const k = m.options.mutationKey?.[1];
  if (typeof k === 'string') return k;
  const v = m.state.variables as { id?: unknown; cardId?: unknown } | undefined;
  if (v && typeof v === 'object') {
    if (typeof v.id === 'string') return v.id;
    if (typeof v.cardId === 'string') return v.cardId;
  }
  return null;
}
